import { Link } from "react-router-dom";
import { ArrowRight, Calculator, ShieldCheck, Award, Clock3 } from "lucide-react";

export default function Hero() {
  return (
    <section
      className="relative isolate overflow-hidden min-h-[92vh] flex items-center"
      data-testid="hero-section"
    >
      <img
        src="https://customer-assets.emergentagent.com/job_baukosten-pro/artifacts/4ilx4lwc_ChatGPT%20Image%205.%20Juni%202026%2C%2023_41_21.png"
        alt="Architekturentwurf eines modernen Einfamilienhauses – EasyRohbau"
        className="absolute inset-0 w-full h-full object-cover object-right -z-20"
        loading="eager"
      />
      {/* Soft white-to-transparent gradient from the left so the text stays readable
          on top of the bright illustration, while the architecture stays fully visible on the right. */}
      <div
        className="absolute inset-0 -z-10"
        style={{
          background:
            "linear-gradient(90deg, rgba(255,255,255,0.96) 0%, rgba(255,255,255,0.92) 38%, rgba(255,255,255,0.55) 60%, rgba(255,255,255,0.0) 80%)",
        }}
      />
      <div className="absolute inset-0 blueprint-bg opacity-30 -z-10 pointer-events-none" />

      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 pt-28 md:pt-20 pb-16 w-full">
        <div className="reveal-up max-w-2xl">
          <p className="inline-flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] text-[#2873B8] mb-6">
            <span className="h-px w-8 bg-[#2873B8]" />
            Rohbau · Düsseldorf &amp; NRW
            <span className="h-px w-8 bg-[#2873B8]" />
          </p>
          <h1
            className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05] tracking-tight mb-4 text-[#0C2749]"
            style={{ fontFamily: "Outfit" }}
          >
            Wir bauen das Fundament <br />
            <span className="text-[#2873B8]">Ihres Vorhabens.</span>
          </h1>
          <p
            className="text-base md:text-lg font-medium text-[#2873B8] mb-6 tracking-tight"
            style={{ fontFamily: "Outfit" }}
            data-testid="hero-slogan"
          >
            Stein für Stein zu Ihrem Heim.
          </p>
          <p className="text-base md:text-lg text-slate-700 max-w-xl leading-relaxed mb-10">
            EasyRohbau realisiert Premium-Rohbauprojekte für anspruchsvolle Bauherren, Architekten und Bauträger.
            Termintreue. Festpreisgarantie. Sichtbeton-Qualität.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 mb-12">
            <Link
              to="/preisrechner"
              data-testid="hero-cta-primary"
              className="btn-shimmer inline-flex items-center justify-center gap-2 bg-[#0C2749] hover:bg-[#2873B8] text-white px-7 py-4 rounded-sm font-medium transition-colors text-base"
            >
              <Calculator className="w-5 h-5" />
              KI-Preis in 60 Sekunden
              <ArrowRight className="w-4 h-4" />
            </Link>
            <Link
              to="/kontakt"
              data-testid="hero-cta-secondary"
              className="inline-flex items-center justify-center gap-2 border border-[#0C2749]/20 hover:bg-[#0C2749] hover:text-white text-[#0C2749] px-7 py-4 rounded-sm font-medium transition-colors text-base"
            >
              Kostenlose Beratung
            </Link>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-4 max-w-2xl">
            {[
              { icon: Award, label: "Festpreis-Garantie" },
              { icon: Clock3, label: "98% Termintreue" },
              { icon: ShieldCheck, label: "Voll versichert" },
              { icon: Award, label: "21+ Jahre" },
            ].map((it, i) => (
              <div key={i} className="flex items-center gap-2 text-[#0C2749] text-sm">
                <it.icon className="w-4 h-4 text-[#2873B8]" />
                {it.label}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
